import React, { useEffect, useState } from "react";
import ToggleButtons from "../../stories/Buttons/ToggleButtons";
import { Col, Row, Container, Spinner } from "react-bootstrap";
import { Formik, Form } from "formik";
import { Button } from "../../stories/Buttons/Button";
import useApis from "../../services/useAPI";
import { useNavigate, useParams } from "react-router-dom";
import { DNAAsstFields } from "../../stories/Forms/fields";
import { dnaAssessmentSchema } from "../../stories/Forms/validationSchema";
import { ErrorDisplay } from "../Errors/ErrorDisplay";
import {getUserHealthInformtion} from "../../utils/constants"

/**
 * Component for the Wellness DNA Assessment form.
 * Allows users to provide dietary preferences and restrictions.
 */

const WellnessAssessment = () => {

  const params = useParams()
  const { test_kit_id } = params
  const url = `/api/dashboard/assessment/dna/${test_kit_id}`;
  const navigate = useNavigate()
  const [error, setError] = useState("");
  const userId = localStorage.getItem("user_id");

  const { callApi, resultPost, serverError, isLoading, resultGet } = useApis();

  const handleSubmitNew = values => {
    const data = {
      dairy: values.dairy,
      nuts: values.nuts,
      gluten: values.gluten,
      shellfish: values.shellfish,
      oily_fish: values.oily_fish,
      eggs: values.eggs,
      pork: values.pork,
      poultry: values.poultry,
      alcohol: values.alcohol,
      red_meat: values.red_meat
    };

    callApi(data, url, "POST");

  };

  useEffect(() => {
    setError(serverError);
  }, [serverError])

  useEffect(() => {
    if (resultPost) {
      navigate('/')
    }
  }, [resultPost])

  const [initialValues, setInitialValues] = useState(
    DNAAsstFields.reduce((acc, field) => {
      acc[field.name] = "";
      return acc;
    }, {})
  );

useEffect(() => {
  const fetchHealthInfo = async () => {
    try {
      const response = await callApi(
        null,
        getUserHealthInformtion(userId),
        "GET"
      );

      if (response?.dietary_preferences) {
        setInitialValues(response.dietary_preferences);
      }
    } catch (err) {
      setError(err);
    }
  };

  if (userId) {
    fetchHealthInfo();
  }
}, [userId]);

  if (error) {
    return <ErrorDisplay error={error} consent={false} />;
  }

  if (isLoading) {
    return <div className="text-center">
      <Spinner  animation="border" variant="info" className="my-custom-spinner"/>
    </div>;
  }
  return (
    <div className="row justify-content-center wellness-assessment-page">
      <div className="col-md-12">
        <h1 className="mb-4">Wellness DNA assessment</h1>
        <div className="text-dark font-weight-bold">
          Please provide some basic details about yourself. We'll use this to
          customize your reports.
        </div>
        <p className="std-top-md">
          For the following please tell us which you can't eat (allergy or
          religious restriction), don't eat, or those you eat.
        </p>

        <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmitNew} validationSchema={dnaAssessmentSchema}>
          {({ values, setFieldValue, errors, touched }) => (
            <Form>
              <Container fluid className="p-0">
                <Row>
                  {DNAAsstFields.map((field, index) => (
                    <Col md={6} xl={4} xs={12} key={field.controlId}>
                      <div className="std-top-md">
                        <div className="form-group">
                          <ToggleButtons
                            field={field}
                            setFieldValue={setFieldValue}
                            errors={errors}
                            touched={touched}
                            genderIdentityProp={values[field.name]}
                          />
                        </div>
                      </div>
                    </Col>
                  ))}

                  <Col
                    sm={12}
                    md={12}
                    xl={12}
                    xs={12}
                    className="d-flex justify-content-end"
                  >
                    <div className="btn-group wellness-assessment-btn-container">
                      <Button
                        label={"Skip"}
                        size={"small"}
                        className={"capsule-left-button btn-secondary"}
                        onClick={() => navigate('/')} />
                      <Button
                        label={"Submit"}
                        type="submit"
                        size={"small"}
                        className={"capsule-right-button"}
                      />
                    </div>
                  </Col>
                </Row>
              </Container>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

export default WellnessAssessment;
